import React, { useState } from "react";
import { Box, Button, Stack } from "@mui/material";
import { MenuDropDown } from "./dropDownMenu";
import NotificationContainer from "./notification";
import useResponsive from "../../../hooks/useResponsive";
import { useTheme } from "@mui/material/styles";
import { SmallScreenDrawer } from "../drawer";

const Header: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  const isDesktop = useResponsive("down", "lg", "xl");
  const isSmall = useResponsive("down", "sm", "xl");
  const containerPadding = 20; // Assuming 20px padding on the container

  const handleModal = () => setOpen(!open);
  return (
    <Box
      sx={{
        position: "sticky",
        zIndex: 20,
        width: '100%',
        top: 0,
        overflowX: "hidden",
        display: "flex",
        gap: isMedium ? "4px" : "10px",
        alignItems: "center",
        background: theme.palette.common.white,
        transition: "margin-left 0.3s", // Smooth transition for sidebar toggle
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: isMedium ? "4px" : "10px",
          alignItems: "center",
          width: '100%',
          background: theme.palette.common.white,
          paddingX: "1rem",
        }}
      >
        {isDesktop && <SmallScreenDrawer />}
        {children}
        <Stack
          direction={isSmall ? "column" : "row"}
          sx={{ gap: "10px", ml: "auto" }}
          alignItems={"center"}
        >
          {!isSmall && <NotificationContainer />}
          <MenuDropDown handleModal={handleModal} />
        </Stack>
      </Box>
    </Box>
  );
};

export default Header;
